import React, { createContext, memo, useReducer } from 'react';
import { defaultPagesState, pagesReducer } from './pagesReducer';
var store = createContext({
    pages: defaultPagesState,
    dispatchPages: function () {
    }
});
var Provider = store.Provider;
export var usePages = function () { return React.useContext(store); };
export var PagesProvider = memo(function (_a) {
    var children = _a.children;
    var _b = useReducer(pagesReducer, defaultPagesState), pages = _b[0], dispatchPages = _b[1];
    return (React.createElement(Provider, { value: { pages: pages, dispatchPages: dispatchPages } }, children));
});
